export const getInsurance = ({ insurance }) => insurance

export const getForm = (state) => getInsurance(state).form

export const getView = (state) => getInsurance(state)._view.value

export const getStatusLabels = (state) => getView(state).statusLabels
